<template>
    <div v-if="user" class="md-content">
        <toolbar title="Édition de l'usager" isSave="true" @save="dataSave" />
        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center">
            <div class="md-layout-item md-size-90 ">
                <div class="md-layout md-alignment-top-right">
                    <md-switch v-model="user.isActive" class="md-primary">Actif</md-switch>
                </div>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <md-field :class="$v.user.firstName|validations">
                    <label for="txtfirstName">Prénom</label>
                    <md-input id="txtfirstName" v-model="user.firstName" type="text" required />
                </md-field>
                <md-field>
                    <label for="txtlastName">Nom</label>
                    <md-input id="txtlastName" v-model="user.lastName" type="text" />
                </md-field>
                <md-field>
                    <label for="txtEmail">Courriel</label>
                    <md-input id="txtEmail" v-model="user.email" type="text" />
                </md-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <md-field :class="$v.user.loginName|validations">
                    <label for="txtLoginName">Code usager</label>
                    <md-input id="txtLoginName" v-model="user.loginName" type="text" required />
                </md-field>
                <md-field v-if="test" :class="$v.user.password|validations">
                    <label for="txtPassword">Mot de passe</label>
                    <md-input id="txtPassword" v-model="user.password" type="password" required />
                </md-field>
                <md-field v-else class="">                    
                    <p>Mot de passe: *********</p>
                    <md-button  @click="editPassword()" class="md-icon-button md-dense md-my-auto ">
                        <md-icon class="md-primary">edit</md-icon>
                    </md-button>
                </md-field>
            </div>

            <!-- <div class="md-layout-item md-size-90 md-mt-5 ">
                <label class="md-label">Modifié&nbsp;le:&nbsp;{{user.modifiedOn| YYYYMMDD}} </label>
                <label class="md-label">Par:&nbsp;{{user.modifiedBy}}</label>
            </div> -->
            <div class="md-layout-item md-size-90 md-mt-5 ">
                <label class="md-label">Créé&nbsp;le:&nbsp;{{user.createdOn| YYYYMMDD}} </label>
                <label class="md-label">Par:&nbsp;{{user.createdBy}}</label>
            </div>

        </div>
    </div>
</template>

<script>
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import baseToolbar from '@/components/toolbarBase.vue';

    import { beforeRouteLeaveExtension } from '@/mixins/beforeRouteLeaveExtension.js';
    import { apiSecurityExtension } from '@/mixins/apiSecurityExtension.js';
    import { navigateRouteExtension } from '@/mixins/navigateRouteExtension.js';

    export default {
        name: 'userEdit',
        mixins: [beforeRouteLeaveExtension, apiSecurityExtension, navigateRouteExtension],
        data: () => ({
            user: null,
            changingPassword: false,
        }),
        computed:{
            test: function(){
                if( this.changingPassword || (this.user != null & this.user.id == 0)){
                    return true;
                }else{
                    return false;
                }
            }
        },
        watch: {
            user: {
                deep: true,
                handler(user) {
                    if (this.$v.$init && !this.$v.$anyDirty) { this.$v.$touch(); }
                    else { this.$v.$init = true; }
                }
            }
        },
        validations: {
            user: {
                firstName: { required },
                loginName: { required },
                password: { required: requiredIf(function (model) { return model.id === 0 }) },
            }
        },
        created: function () {
            $App.event.$on("app_hotkey_ctrlS", this.onCtrlS);
        },
        destroyed: function () {
            $App.event.$off("app_hotkey_ctrlS", this.onCtrlS);
        },
        mounted:
            function () {
                this.dataRead();
            },
        methods: {
            dataRead: async function () {

                let data = await this.SecurityUserGetById(this.$route.params.id);
                if (data) {
                    this.user = data;
                }
            },
            dataSave: async function () {

                this.$v.$touch()
                if (!this.$v.$invalid) {

                    let data = await this.SecurityUserSave(this.user);
                    if (data) {
                        this.$v.$reset();
                        this.navigateBack({ name: 'user_List' });
                    }
                }
            },
            onCtrlS: function (e) {
            this.dataSave();
            },
            editPassword(){
                this.changingPassword = true;
            },
        },
        components: {
            toolbar: baseToolbar
        }
    }
</script>